import { Path } from "components";

const Man = ({ pieces }) => {
  const parts = [
    <g id="head_2" key="head">
      <Path
        id="Ellipse 1"
        d="M57.726 163.437C54.6851 172.527 48.9987 179.956 40 179.956C35.7945 179.956 32.7066 178.663 30.306 176.397C27.8734 174.1 26.0764 170.738 24.6149 166.484C22.929 161.577 22.6008 156.253 24.2411 151.428C26.8917 143.632 31.9744 138 40 138C49.2014 138 56.6385 144.894 58.5342 154.291C59.1391 157.289 58.7287 160.439 57.726 163.437Z"
        fill="#F8F3E7"
        stroke="#6D6A75"
        strokeWidth={2}
      />
      <path
        id="Vector 23"
        opacity={0.4}
        d="M56 168.5C56.319 167.795 56.6601 166.979 56.9977 166.126C58.0644 163.428 58.407 160.512 58.2261 157.618L58.1881 157.009C58.0635 155.016 57.6233 153.055 56.8838 151.199L55.9141 148.766C55.2905 147.202 54.256 145.834 52.9198 144.809C49.0229 141.819 43.4768 142.353 40.2221 146.032L36.5081 150.23C35.1822 151.729 34.1618 153.472 33.5044 155.362L32.4464 158.404C31.1951 162.001 31.3481 165.939 32.8747 169.428L34.5227 173.195C36.2807 177.213 40.5098 179.558 44.8493 178.921L45.3812 178.843C46.4473 178.687 47.6189 178.62 48.5 178C49.6119 177.217 50.5633 176.527 51.5 175.5C53.4304 173.384 54.7867 171.18 56 168.5Z"
        fill="#6D6A75"
        fillOpacity={0.22}
      />
    </g>,
    <Path
      id="left-arm"
      d="M13.944 208.38L19.3893 164.43C19.7381 161.614 22.1303 159.5 24.9673 159.5C28.2278 159.5 30.8042 162.265 30.574 165.518L27.4465 209.694C27.1949 213.246 24.2395 216 20.678 216C16.5995 216 13.4426 212.428 13.944 208.38Z"
      fill="#F8F3E7"
      stroke="#6D6A75"
      strokeWidth={2}
      key="left-arm"
    />,
    <Path
      id="right-arm"
      d="M56 202.808V162.19C56 158.876 59.2195 156.517 62.3798 157.515C64.2689 158.111 65.6135 159.786 65.7876 161.759L69.3577 202.22C69.7029 206.133 66.6197 209.5 62.6918 209.5C58.996 209.5 56 206.504 56 202.808Z"
      fill="#F8F3E7"
      stroke="#6D6A75"
      strokeWidth={2}
      key="right-arm"
    />,
    <Path
      id="body"
      d="M30 157H61C63.7614 157 66 159.239 66 162V189.162C66 193.927 64.764 198.61 62.4128 202.754L61.1011 205.066C54.3112 217.034 39.1668 221.327 27.1069 214.702C25.8075 213.989 25 212.624 25 211.141V162C25 159.239 27.2386 157 30 157Z"
      fill="#FCBF49"
      stroke="#6D6A75"
      strokeWidth={2}
      key="body"
    />,
    <Path
      id="legs"
      d="M25 283.562V222.572C25 220.996 26.4862 219.843 28.0125 220.235L32.9244 221.496C42.5697 223.973 52.7902 220.847 59.4003 213.399C60.3114 212.372 62.0088 213.003 62.0285 214.375L62.8928 274.71C62.9518 278.824 59.6331 282.191 55.5187 282.191C52.3508 282.191 49.7827 279.623 49.7827 276.455V240.294C49.7827 235.174 43.6179 232.58 39.9569 236.16C38.8445 237.248 38.2175 238.738 38.2175 240.294V262.135V283.562C38.2175 287.338 35.059 290.346 31.2874 290.163C27.7666 289.991 25 287.087 25 283.562Z"
      fill="#F8F3E7"
      stroke="#6D6A75"
      strokeWidth={2}
      key="legs"
    />,
  ];

  return (
    <g id="man">{parts.filter((_, index) => index <= pieces - 1).reverse()}</g>
  );
};

export default Man;
